document.addEventListener('DOMContentLoaded', () => {
    const configEl = document.querySelector('[data-cart-config]');
    if (!configEl) {
        return;
    }

    const deleteConfirmMessage = configEl.dataset.deleteConfirmMessage || '';
    const deleteRouteBase = configEl.dataset.deleteRouteBase || '';
    const requestConfirmRoute = configEl.dataset.requestConfirmRoute || '';

    const requestConfirmBtn = document.getElementById('js-btn-request-confirm');

    if (requestConfirmBtn && requestConfirmRoute) {
        requestConfirmBtn.classList.remove('is-disabled');
        requestConfirmBtn.href = requestConfirmRoute;
    }

    document.querySelectorAll('.js-cart-delete-btn').forEach((btn) => {
        btn.addEventListener('click', async (event) => {
            event.preventDefault();
            const cartDetailId = btn.dataset.cartDetailId;

            const isConfirmed = await window.showConfirm(deleteConfirmMessage);
            if (!isConfirmed) {
                return;
            }

            const form = document.createElement('form');
            form.method = 'POST';
            form.action = deleteRouteBase.replace('__ID__', cartDetailId);

            const csrfInput = document.createElement('input');
            csrfInput.type = 'hidden';
            csrfInput.name = '_token';
            csrfInput.value = document.querySelector('meta[name="csrf-token"]')?.content || '';
            form.appendChild(csrfInput);

            document.body.appendChild(form);
            form.submit();
        });
    });
});
